export const PlantItemRenewalReviewItemPage = {
  itemTypeLabel: 'Type',
  itemSerialNumberLabel: 'Serial number',
  itemSpecificLocationLabel: 'Specific location of the item',
  itemUniqueIdLabel: 'Unique identifier',
  itemNameOfDeviceLabel: 'Name of device',
  itemOtherTypeDescLabel: 'Other type description',
  itemModelNameOrNumberLabel: 'Model name/number',
  itemExpiryDateLabel: 'Expiry date',
  itemConditionsLabel: 'Conditions',

  renewalDetailsTitle: 'Renewal details',
  renewalNumberLabel: 'Renewal number',
  itemRegistrationNumberLabel: 'Item registration number',
  itemLocationPostcodeLabel: 'Postcode of item location',
  locationAddressLabel: 'Location address',
  ownerLabel: 'Owner',
};
